const PLATFORM_HOSTS = new Set([
  "belezaebronze.club",
  "www.belezaebronze.club",
]);

/**
 * Detecta apenas hosts que podem tentar abrir uma loja. A autorização e a
 * associação real continuam no servidor por domínio previamente verificado.
 */
export function getCustomStoreDomainFromLocation(): string | null {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname.trim().toLowerCase().replace(/\.$/, "");
  if (
    !host ||
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "::1" ||
    PLATFORM_HOSTS.has(host) ||
    host.endsWith(".manus.space") ||
    host.endsWith(".manus.computer")
  ) {
    return null;
  }
  return host;
}
